<template>
  <ul class="post__widgets d-flex list-unstyled">
    <li class="d-flex align-items-center">
      <a href="#post-comments-widget">
          <img src="/assets/images/icons/comments.svg" alt="" />
          <span v-text="post.comments_count"></span>
      </a>  
    </li>
    <li>
      <button @click.prevent="handleLikeArticle()">
        <img :src="postLikedIcon" alt="" />
      </button>
    </li>
    <li>
        <a 
            href="#"
            data-toggle="modal"
            data-target="#socilaShareModal"
        >
            <img
                src="/assets/images/icons/share.svg"
                alt=""
            />
        </a>  
    </li>
  </ul>
</template>

<script>
import { isPostLiked, postLikedIcon, handleLikePost } from './isPostLikedStore'
import { likeArticle } from '../api'

export default {
    name: "PostWidgets",
    props: {
        post: { required: true, type: Object }
    },

    created(){
        this.handleLikePost(this.post.follow)
    },

    isPostLiked,
    computed: {
        postLikedIcon,
    },

    methods: {
      handleLikePost,
      async handleLikeArticle(){
        try{
          let params = { post_id: this.post.id, follow: ! Number(this.$options.isPostLiked.value) }

          let { data: { success = false } } = await likeArticle({ params })

          if( success ) this.handleLikePost( Boolean(params.follow) )

        } catch( e ){
          console.log(e);
        }

      }
    }
};
</script>